"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _validate = require("@/libs/validate1.js");
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//数据库里需要存两份图片地址，一张为原图地址，一张为裁剪后的头像地址
var _default = exports.default = {
  data: function data() {
    return {
      userInfo: {
        avatarUrl: this.avatar,
        name: ""
      },
      userImg: require("@/assets/img/userHD.png"),
      dialogVisible: false,
      rules: {
        name: [{
          required: true,
          message: "请输入昵称",
          trigger: "blur"
        }, {
          min: 1,
          max: 10,
          message: "长度在 1 到 10 个字符",
          trigger: "blur"
        }],
        tel: [{
          required: true,
          message: "请输入联系方式",
          trigger: "blur"
        }, {
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }],
        mail: [{
          required: true,
          message: "请输入邮箱",
          trigger: "blur"
        }, {
          validator: _validate.validateEMail,
          trigger: "blur"
        }]
      },
      imgFile: ""
    };
  },
  methods: {
    // 表单提交
    submitForm: function submitForm(val) {
      var _this = this;
      this.$refs[val].validate(function (valid) {
        if (valid) {
          _this.$store.dispatch("user/upDateUserInfo", _this.userInfo).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success("修改成功。");
            }
          });
        } else {
          _this.$message.error("修改失败，请先检查填写信息");
        }
      });
    },
    resetForm: function resetForm(val) {
      this.$refs[val].resetFields();
    },
    successUpLoad: function successUpLoad(res) {
      this.userInfo.avatarUrl = res.ossOriUrl;
    },
    isBack: function isBack() {
      history.go(-1);
    }
  },
  components: {
    FileImg: _index.default
  },
  computed: _objectSpread({}, (0, _vuex.mapState)({
    avatar: function avatar(state) {
      return state.user.avatar;
    },
    userName: function userName(state) {
      return state.user.name;
    }
  })),
  created: function created() {
    this.userInfo.name = this.userName;
  }
};